/** Routes that redirect immediately and never render a primary landmark. */
const INSTANT_REDIRECT_PATHS = new Set(['/claims/other/gst', '/claims/windscreen/gst'])

/** Routes with no meaningful primary content for skip navigation. */
const SKIP_LINK_HIDDEN_PATHS = new Set(['/auth/redirect'])

export interface ShouldRenderSkipLinkOptions {
  /** Full-screen post-login bootstrap (no page shell yet). */
  postLoginLoading?: boolean
}

/**
 * Whether the global skip link should render for the current route.
 * Hidden only on transient shells; all other routes must expose `#main`.
 */
export function shouldRenderSkipLink(
  pathname: string,
  options: ShouldRenderSkipLinkOptions = {}
): boolean {
  if (options.postLoginLoading) return false
  if (SKIP_LINK_HIDDEN_PATHS.has(pathname)) return false
  if (INSTANT_REDIRECT_PATHS.has(pathname)) return false
  return true
}
